<template functional>
  <div>
    <template v-if="props.state === 'TO_HANDLE'">
      <i class="el-icon-circle el-icon-time" style="background-color:#005bff"></i>
      <span style="color:#005bff">待平台处理</span>
    </template>
    <template v-else-if="props.state === 'HANDLED'">
      <i class="el-icon-circle el-icon-circle-check" style="background-color:#888888"></i>
      <span style="color:#888888">平台已处理</span>
    </template>
    <template v-else-if="props.state === 'HANDLING'">
      <i class="el-icon-circle el-icon-remove-outline" style="background-color:#00bd83"></i>
      <span style="color:#00bd83">平台处理中</span>
    </template>
    <template v-else-if="props.state === 'CANCELLED'">
      <i class="el-icon-circle el-icon-sort-down" style="background-color:#dadde0;transform:rotate(-90deg);"></i>
      <span style="color:#dadde0;">买家已撤销</span>
    </template>
    <template v-else>
      <i class="el-icon-circle el-icon-circle-close" style="background-color:#ff5753"></i>
      <span style="color:#ff5753">平台已驳回</span>
    </template>
  </div>
</template>
<script>
export default {
  name: 'handleLabel',
  props: ['state']
};
</script>
